import { useNativeExpandableSheetProps } from "@/lib/native/useNativeExpandableSheetProps";
import { cn } from "@/lib/utils";

/** Expandable native bottom sheet props for content-heavy dealer portal dialogs. */
export function useDealerPortalNativeSheetProps(
  open: boolean,
  className?: string,
) {
  return useNativeExpandableSheetProps(open, {
    nativeClass:
      "native-dealer-portal-sheet native-sheet-expandable max-w-none w-[calc(100%-1rem)]",
    className,
  });
}
